// CSS Modules - component class name prefix: ContactList__

<template>
  <div>
    <div v-if="!state.contentLoaded" class="preloadFilter">
      <Loading />
    </div>
    <form v-if="state.contentLoaded && !config.worldwide && state.data.zip">
      <div
        :class="[
          $style.filter,
          'columns is-gapless',
          { ['is-mobile']: state.isMobile }
        ]"
      >
        <div class="column">
          <FormInput
            v-model="state.zipValue"
            :errorMessage="state.data.zip.errorMessage"
            :error="!isZip && state.zipValue !== null && state.zipValue !== ''"
            :placeholder="state.data.zip.placeholderText"
            @input="zipActive = false"
            ariaLabel="enter zip"
          />
        </div>
        <div class="column">
          <Button
            colour="blue"
            type="submit"
            :isForm="true"
            @close="handleSubmit"
            :class="$style.searchBtn"
          >
          </Button>
        </div>
      </div>
    </form>
    <div
      :class="$style.zipResultText"
      v-if="
        state.contentLoaded && !config.worldwide && state.data.zip && zipActive
      "
      v-html="
        state.data.zip.resultMessage.replace(
          /\{.*?\}/g,
          `<strong>${state.zipValue}</strong>`
        )
      "
    ></div>
    <div
      v-if="
        state.contentLoaded &&
          !config.worldwide &&
          state.data.group &&
          state.data.group.useFilter
      "
      :class="[$style.filter, $style.groupFilter]"
    >
      <FormSelect
        :hasFilter="false"
        v-model="state.filter.initialSelectOption"
        :colour="state.filter.colour"
        :options="state.selectOptions"
        :initialOption="state.filter.initialSelectOption"
        @input="updateFilter"
      />
    </div>
    <div v-if="state.activeTab === tab && state.data.zip">
      <div :key="ind" v-for="(range, ind) in state.content">
        <div
          v-if="
            zipActive &&
              isZip &&
              state.zipValue >= range.from &&
              state.zipValue <= range.to &&
              range.departments &&
              range.departments.length === 0
          "
          :class="[
            'columns',
            'is-multiline',
            { ['is-mobile']: state.isMobile }
          ]"
        >
          <div class="column is-full"><br /></div>
          <template v-for="(contact, index) in range.contacts">
            <div
              :key="index"
              :class="[
                { [$style.mobileColumn]: state.isMobile },
                'column',
                { ['is-half-mobile']: state.isMobile },
                { ['is-one-third-tablet']: !state.isMobile },
                { ['is-one-quarter-desktop']: !state.isMobile }
              ]"
            >
              <ContactBox
                :id="contact.id"
                :image="contact.image"
                :firstname="contact.firstname"
                :lastname="contact.lastname"
                :position="contact.position"
                :company="contact.company"
                :address="contact.address"
                :phone="contact.phone"
                :fax="contact.fax"
                :email="contact.email"
                :formEmail="contact.formEmail"
                :website="contact.website"
                :vcard="contact.vcard"
                :useForm="config.useForm"
              />
            </div>
          </template>
        </div>
        <div
          v-if="
            zipActive &&
              isZip &&
              state.zipValue >= range.from &&
              state.zipValue <= range.to &&
              range.departments &&
              range.departments.length !== 0
          "
          :class="[
            'columns',
            'is-multiline',
            { ['is-mobile']: state.isMobile }
          ]"
        >
          <h2 :class="[$style.subHeadline, 'column is-full']">
            <hr />
            {{ range.departments[0] }}
          </h2>
          <template v-for="(contact, index) in range.contacts">
            <div
              :key="index"
              v-if="contact.departments[0] === range.departments[0]"
              :class="[
                { [$style.mobileColumn]: state.isMobile },
                'column',
                { ['is-half-mobile']: state.isMobile },
                { ['is-one-third-tablet']: !state.isMobile },
                { ['is-one-quarter-desktop']: !state.isMobile }
              ]"
            >
              <ContactBox
                :id="contact.id"
                :image="contact.image"
                :firstname="contact.firstname"
                :lastname="contact.lastname"
                :position="contact.position"
                :company="contact.company"
                :address="contact.address"
                :phone="contact.phone"
                :fax="contact.fax"
                :email="contact.email"
                :formEmail="contact.formEmail"
                :website="contact.website"
                :vcard="contact.vcard"
                :useForm="config.useForm"
              />
            </div>
          </template>
        </div>
        <div
          v-if="
            zipActive &&
              isZip &&
              state.zipValue >= range.from &&
              state.zipValue <= range.to &&
              range.departments &&
              range.departments.length !== 0
          "
          :class="[
            'columns',
            'is-multiline',
            { ['is-mobile']: state.isMobile }
          ]"
        >
          <h2 :class="[$style.subHeadline, 'column is-full']">
            <hr />
            {{ range.departments[1] }}
          </h2>
          <template v-for="(contact, index) in range.contacts">
            <div
              :key="index"
              v-if="contact.departments[0] === range.departments[1]"
              :class="[
                { [$style.mobileColumn]: state.isMobile },
                'column',
                { ['is-half-mobile']: state.isMobile },
                { ['is-one-third-tablet']: !state.isMobile },
                { ['is-one-quarter-desktop']: !state.isMobile }
              ]"
            >
              <ContactBox
                :id="contact.id"
                :image="contact.image"
                :firstname="contact.firstname"
                :lastname="contact.lastname"
                :position="contact.position"
                :company="contact.company"
                :address="contact.address"
                :phone="contact.phone"
                :fax="contact.fax"
                :email="contact.email"
                :formEmail="contact.formEmail"
                :website="contact.website"
                :vcard="contact.vcard"
                :useForm="config.useForm"
              />
            </div>
          </template>
        </div>
      </div>
    </div>
    <div
      v-if="
        state.activeTab === tab &&
          state.data.group &&
          state.data.group.useFilter
      "
    >
      <div
        :key="ind"
        v-for="(group, ind) in state.content"
        :ref="group.name"
        :class="[
          $style.group,
          'columns is-multiline',
          { ['is-mobile']: state.isMobile }
        ]"
      >
        <template v-if="group.contacts && group.contacts.length > 0">
          <div
            :key="`${ind}-${contactIndex}`"
            v-for="(contact, contactIndex) in group.contacts"
            :class="[
              { [$style.mobileColumn]: state.isMobile },
              'column',
              { ['is-half-mobile']: state.isMobile },
              { ['is-one-third-tablet']: !state.isMobile },
              { ['is-one-quarter-desktop']: !state.isMobile }
            ]"
          >
            <ContactBox
              :id="contact.id"
              :image="contact.image"
              :firstname="contact.firstname"
              :lastname="contact.lastname"
              :position="contact.position"
              :company="contact.company"
              :address="contact.address"
              :phone="contact.phone"
              :fax="contact.fax"
              :email="contact.email"
              :formEmail="contact.formEmail"
              :website="contact.website"
              :vcard="contact.vcard"
              :useForm="config.useForm"
            />
          </div>
        </template>
        <template v-for="(department, departmentIndex) in group.departments">
          <h2
            :key="`${ind}-${departmentIndex}`"
            v-if="state.data.group.splitByGroups"
            :class="[$style.subHeadline, 'column is-full']"
          >
            <hr />
            {{ department.name }}
          </h2>
          <div
            :key="`${ind}-${departmentIndex}-${contactIndex}`"
            v-for="(contact, contactIndex) in department.contacts"
            :class="[
              { [$style.mobileColumn]: state.isMobile },
              'column',
              { ['is-half-mobile']: state.isMobile },
              { ['is-one-third-tablet']: !state.isMobile },
              { ['is-one-quarter-desktop']: !state.isMobile }
            ]"
          >
            <ContactBox
              :id="contact.id"
              :image="contact.image"
              :firstname="contact.firstname"
              :lastname="contact.lastname"
              :position="contact.position"
              :company="contact.company"
              :address="contact.address"
              :phone="contact.phone"
              :fax="contact.fax"
              :email="contact.email"
              :formEmail="contact.formEmail"
              :website="contact.website"
              :vcard="contact.vcard"
              :useForm="config.useForm"
            />
          </div>
        </template>
      </div>
    </div>
    <div
      v-if="
        state.activeTab === tab &&
          state.data.group &&
          !state.data.group.useFilter
      "
    >
      <div
        :class="[
          $style.group,
          $style.active,
          'columns is-multiline',
          { ['is-mobile']: state.isMobile }
        ]"
      >
        <template v-for="(group, ind) in state.content">
          <h2
            :key="ind"
            v-if="state.data.group.splitByGroups"
            :class="[$style.subHeadline, 'column is-full']"
          >
            <hr />
            {{ group.name }}
          </h2>
          <div
            :key="`${ind}-${index}`"
            v-for="(contact, index) in group.contacts"
            :class="[
              { [$style.mobileColumn]: state.isMobile },
              'column',
              { ['is-half-mobile']: state.isMobile },
              { ['is-one-third-tablet']: !state.isMobile },
              { ['is-one-quarter-desktop']: !state.isMobile }
            ]"
          >
            <ContactBox
              :id="contact.id"
              :image="contact.image"
              :firstname="contact.firstname"
              :lastname="contact.lastname"
              :position="contact.position"
              :company="contact.company"
              :address="contact.address"
              :phone="contact.phone"
              :fax="contact.fax"
              :email="contact.email"
              :formEmail="contact.formEmail"
              :website="contact.website"
              :vcard="contact.vcard"
              :useForm="config.useForm"
            />
          </div>
        </template>
      </div>
    </div>
    <div
      v-if="state.activeTab === tab && state.data.contact"
      :class="['columns is-multiline', { ['is-mobile']: state.isMobile }]"
    >
      <div
        :key="index"
        v-for="(contact, index) in state.content"
        :class="[
          { [$style.mobileColumn]: state.isMobile },
          'column',
          { ['is-half-mobile']: state.isMobile },
          { ['is-one-third-tablet']: !state.isMobile },
          { ['is-one-quarter-desktop']: !state.isMobile }
        ]"
      >
        <ContactBox
          :id="contact.id"
          :image="contact.image"
          :firstname="contact.firstname"
          :lastname="contact.lastname"
          :position="contact.position"
          :company="contact.company"
          :address="contact.address"
          :phone="contact.phone"
          :fax="contact.fax"
          :email="contact.email"
          :formEmail="contact.formEmail"
          :website="contact.website"
          :vcard="contact.vcard"
          :useForm="config.useForm"
        />
      </div>
    </div>
    <div v-if="state.activeTab === tab && config.worldwide">
      <WorldWideList :config="worldwideConfig" :useForm="config.useForm" />
    </div>
  </div>
</template>

<script>
import FormSelect from "../FormSelect/FormSelect";
import FormInput from "../FormInput/FormInput";
import Button from "../Button/Button";
import ContactBox from "../ContactBox/ContactBox.vue";
import WorldWideList from "../WorldWideList/WorldWideList";
import Loading from "../Loading/Loading";

export default {
  name: "ContactListEntries",
  components: {
    FormSelect,
    FormInput,
    Button,
    ContactBox,
    Loading,
    WorldWideList
  },
  props: {
    config: {
      type: Object,
      default: () => {}
    },
    state: {
      type: Object,
      default: () => {}
    },
    worldwideConfig: {
      type: Object,
      default: () => {}
    },
    tab: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      zipActive: false,
      isZip: false,
      wtTrack: window.wtTrack
    };
  },
  methods: {
    handleSubmit() {
      this.wtTrack(
        { cat: "SALESBOXCLICK" },
        { inputIdent: this.state.zipValue }
      );
      this.isZip = new RegExp(this.state.data.zip.regex).test(
        this.state.zipValue
      );
      this.zipActive = this.isZip || false;
    },
    updateFilter(value) {
      this.wtTrack({ cat: "SALESBOXCLICK" }, { inputIdent: value });
      for (let ref in this.$refs) {
        if (value === ref) {
          this.$refs[ref][0].classList.remove("ContactListEntries__inactive");
          this.$refs[ref][0].classList.add("ContactListEntries__active");
        } else {
          this.$refs[ref][0].classList.remove("ContactListEntries__active");
          this.$refs[ref][0].classList.add("ContactListEntries__inactive");
        }
      }
    }
  },
  mounted() {
    if (this.state.data.zip && this.state.zipValue) {
      this.handleSubmit();
    }
  }
};
</script>

<style module lang="scss">
@import "./ContactList.scss";
</style>
